
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import GlobalNavbar from '../../components/feature/GlobalNavbar';
import SimulatorHero from './components/SimulatorHero';
import SimulatorTool from './components/SimulatorTool';
import PropertyShowcase from './components/PropertyShowcase';
import SimulatorCTA from './components/SimulatorCTA';
import SimulatorFooter from './components/SimulatorFooter';

export default function SimulatorPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === '#simulator') {
      const element = document.getElementById('simulator');
      if (element) {
        try {
          // 'instant' is not a valid value for `behavior`; use 'auto' for immediate scroll
          element.scrollIntoView({ behavior: 'auto', block: 'start' });
        } catch (err) {
          // Fallback for unexpected browser issues
          console.error('Failed to scroll to simulator element:', err);
        }
      } else {
        console.warn('Simulator element not found for scrolling.');
      }
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white font-inter">
      <GlobalNavbar />
      <SimulatorHero />
      <SimulatorTool />
      <PropertyShowcase />
      <SimulatorCTA />
      <SimulatorFooter />
    </div>
  );
}
